import request from "../request";
const server = {
  addMessage: function (params) {
    return request.post('/user-center/messageBoard/add', params)
  },
}

export default server